import axiosInstance from "../../../helpers/api";

export const getLiveVideos = (body) => {
  return axiosInstance.get("/admin/live_videos", body);
};

export const createLiveVideo = (formData) => {
  return axiosInstance.post("/admin/live_videos", formData);
};

export const livevideoReport = (id) => {
  return axiosInstance.get(`/admin/live_videos/${id}`);
};

export const toggleActiveLiveVideo = (id) => {
  return axiosInstance.put(`/admin/live_videos/toggle_active/${id}`);
};

export const updateLiveVideo = (id, formData) => {
  return axiosInstance.post(`/admin/live_videos/update/${id}`, formData);
};

export const deleteLiveVideo = (id) => {
  return axiosInstance.delete(`/admin/live_videos/${id}`);
};
